import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axiosSetUp from './utils/axios'
import generalFunctions from './mixins/getFunc'
import './style.css'

axiosSetUp()

Vue.config.productionTip = false
Vue.mixin(generalFunctions)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
